import { render, staticRenderFns } from "./AssTabprecoProdutoModal.vue?vue&type=template&id=52e54627&scoped=true"
import script from "./AssTabprecoProdutoModal.vue?vue&type=script&lang=js"
export * from "./AssTabprecoProdutoModal.vue?vue&type=script&lang=js"
import style0 from "./AssTabprecoProdutoModal.vue?vue&type=style&index=0&id=52e54627&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e54627",
  null
  
)

export default component.exports